import React from 'react'
import './Reviews.css';
export default function Reviews() {
  return (
   <>
   
   
   
   
   
   <section class="testimonials-section">
        <h2>What Our Clients Say About Apollo Agency</h2>
        <div class="testimonials-container">
          
            <div class="testimonial-card">
                <div class="testimonial-name">Rajkumar</div>
                <div class="testimonial-stars">★★★★★</div>
                <p class="testimonial-review">"Excellent service! The team at Apollo Agency exceeded all my expectations."</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Dharnai</div>
                <div class="testimonial-stars">★★★★☆</div>
                <p class="testimonial-review">"Very professional and reliable service. Highly recommend!"</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Amutha</div>
                <div class="testimonial-stars">★★★★★</div>
                <p class="testimonial-review">"Apollo Agency delivers on time with great quality. A fantastic experience!"</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Arun</div>
                <div class="testimonial-stars">★★★★☆</div>
                <p class="testimonial-review">"Good experience overall. Could improve a bit on communication."</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Stephen</div>
                <div class="testimonial-stars">★★★★★</div>
                <p class="testimonial-review">"Top-notch services! They really know how to take care of their clients."</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Mahendran</div>
                <div class="testimonial-stars">★★★★★</div>
                <p class="testimonial-review">"The best agency I've worked with. Great attention to detail."</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Latha</div>
                <div class="testimonial-stars">★★★★☆</div>
                <p class="testimonial-review">"Amazing work! I am very satisfied with their service."</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Mani Maran</div>
                <div class="testimonial-stars">★★★★★</div>
                <p class="testimonial-review">"Outstanding support and execution. Apollo Agency is the best!"</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Mahesh</div>
                <div class="testimonial-stars">★★★★☆</div>
                <p class="testimonial-review">"Great results delivered within time. Highly recommend their services."</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Palani</div>
                <div class="testimonial-stars">★★★★★</div>
                <p class="testimonial-review">"Professional and efficient. Their services are worth every penny."</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Nagendran</div>
                <div class="testimonial-stars">★★★★★</div>
                <p class="testimonial-review">"Apollo Agency has helped my business grow significantly. Highly recommended!"</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Bose</div>
                <div class="testimonial-stars">★★★★☆</div>
                <p class="testimonial-review">"Impressive results! I am very happy with the outcomes."</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Selvi</div>
                <div class="testimonial-stars">★★★★★</div>
                <p class="testimonial-review">"They understand their clients' needs perfectly and deliver accordingly."</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Madhan</div>
                <div class="testimonial-stars">★★★★☆</div>
                <p class="testimonial-review">"Reliable and trustworthy service. Thank you, Apollo Agency!"</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Prabu</div>
                <div class="testimonial-stars">★★★★★</div>
                <p class="testimonial-review">"Excellent job! Highly recommend them for quality and professionalism."</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Bala Kumar</div>
                <div class="testimonial-stars">★★★★★</div>
                <p class="testimonial-review">"Apollo Agency has never let us down. Truly exceptional service."</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Rithis Kumar</div>
                <div class="testimonial-stars">★★★★☆</div>
                <p class="testimonial-review">"Great experience working with them. I will definitely come back."</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Murugan</div>
                <div class="testimonial-stars">★★★★★</div>
                <p class="testimonial-review">"Highly satisfied with the level of service and professionalism."</p>
            </div>
            <div class="testimonial-card">
                <div class="testimonial-name">Santhose</div>
                <div class="testimonial-stars">★★★★★</div>
                <p class="testimonial-review">"Amazing work! The team was very supportive and helpful."</p>
            </div>
        </div>
    </section>
   
   
   </>
  )
}
